import { render, staticRenderFns } from "./breadCumb.vue?vue&type=template&id=40f7056e&scoped=true&"
import script from "./breadCumb.vue?vue&type=script&lang=js&"
export * from "./breadCumb.vue?vue&type=script&lang=js&"
import style0 from "./breadCumb.vue?vue&type=style&index=0&id=40f7056e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f7056e",
  null
  
)

export default component.exports